// Register programme G4 (owner decision, 5 Oct 2026): one set of checks per unit, scored the
// same way everywhere. A building's register is complete when every unit passes every check.
export const registerChecks = ['has_owner', 'records_agree', 'has_lease', 'has_share', 'has_contact', 'verified'];
export const registerCheckLabels = {
    has_owner: 'Owner',
    records_agree: 'Records agree',
    has_lease: 'Lease',
    has_share: 'Service charge share',
    has_contact: 'Owner contact details',
    verified: 'Checked by staff',
};
export const registerCheckGaps = {
    has_owner: 'No owner contact on the ownership record',
    records_agree: 'Leases or roles disagree with the ownership record',
    has_lease: 'No current lease recorded',
    has_share: 'Missing a service charge share on a schedule that covers it',
    has_contact: 'No email or phone for any owner',
    verified: 'Unit or ownership not yet checked by staff',
};
export const registerCheckMissing = {
    has_owner: 'No owner',
    records_agree: 'Records disagree',
    has_lease: 'No lease',
    has_share: 'No share',
    has_contact: 'No contact details',
    verified: 'Not checked',
};
export function registerScore(units) {
    const possible = units.length * registerChecks.length;
    const passed = units.reduce((sum, unit) => sum + registerChecks.filter(check => unit[check]).length, 0);
    const complete = units.filter(unit => registerChecks.every(check => unit[check])).length;
    return { units: units.length, complete, passed, possible, percent: possible ? Math.floor(passed * 100 / possible) : 0,
        gaps: Object.fromEntries(registerChecks.map(check => [check, units.filter(unit => !unit[check]).length])) };
}
//# sourceMappingURL=register-completeness.js.map